<template>
  <div class="setLink">
    <!-- 링크 타입 선택 -->
    <div class="innerGroup toCapitalize">
      <div class="mb10 linkType">
        <span v-if="!(fixList && !fixList.includes('page'))" class="checkbox radio" :class="{disabled: fixList && !fixList.includes('page')}">
          <input type="radio" :name="`${id}_link_type`" :id="`${id}_link_category`" value="page" v-model="link.type" :disabled="fixList && !fixList.includes('page')">
          <label :for="`${id}_link_category`">{{locale.link_page}}</label>
        </span>
        <span v-if="!(fixList && !fixList.includes('shop'))" class="checkbox radio" :class="{disabled: fixList && !fixList.includes('shop')}">
          <input type="radio" :name="`${id}_link_type`" :id="`${id}_link_shop`" value="shop" v-model="link.type" :disabled="fixList && !fixList.includes('shop')">
          <label :for="`${id}_link_shop`">{{locale.shop}}</label>
        </span>
        <span v-if="!(fixList && !fixList.includes('product'))" class="checkbox radio" :class="{disabled: fixList && !fixList.includes('product')}">
          <input type="radio" :name="`${id}_link_type`" :id="`${id}_link_product`" value="product" v-model="link.type" :disabled="fixList && !fixList.includes('product')">
          <label :for="`${id}_link_product`">{{locale.product}}</label>
        </span>
        <span v-if="!(fixList && !fixList.includes('reservation'))" class="checkbox radio" :class="{disabled: fixList && !fixList.includes('reservation')}">
          <input type="radio" :name="`${id}_link_type`" :id="`${id}_link_reservation`" value="reservation" v-model="link.type" :disabled="fixList && !fixList.includes('reservation')">
          <label :for="`${id}_link_reservation`">{{locale.reservation}}</label>
        </span>
        <span v-if="!(fixList && !fixList.includes('shortcut'))" class="checkbox radio" :class="{disabled: fixList && !fixList.includes('shortcut')}">
          <input type="radio" :name="`${id}_link_type`" :id="`${id}_link_shortcut`" value="shortcut" v-model="link.type" :disabled="fixList && !fixList.includes('shortcut')">
          <label :for="`${id}_link_shortcut`">{{locale.link_shortcut}}</label>
        </span>
        <span v-if="!(fixList && !fixList.includes('outlink'))" class="checkbox radio" :class="{disabled: fixList && !fixList.includes('outlink')}">
          <input type="radio" :name="`${id}_link_type`" :id="`${id}_link_outlink`" value="outlink" v-model="link.type" :disabled="fixList && !fixList.includes('outlink')">
          <label :for="`${id}_link_outlink`">{{locale.link_outlink}}</label>
        </span>
        <span v-if="!(fixList && !fixList.includes('func'))" class="checkbox radio" :class="{disabled: fixList && !fixList.includes('func')}">
          <input type="radio" :name="`${id}_link_type`" :id="`${id}_link_func`" value="func" v-model="link.type" :disabled="fixList && !fixList.includes('func')">
          <label :for="`${id}_link_func`">{{locale.link_func}}</label>
        </span>
      </div>
    </div>
    <!-- //링크 타입 선택 -->
    <div class="setDetail">
      <div class="mb15 toCapitalize">
        <!-- 아웃링크 -->
        <SetLanguageValue v-if="link.type === 'outlink'"
          :locale="locale"
          :langValue="link.url" />
        <!-- //아웃링크 -->
        <!-- 페이지 -->
        <div v-else-if="link.type === 'page'">
          <!-- 페이지 리스트를 선택하지 않고 직접 pageid를 입력 -->
          <div v-if="pageIdInput" class="mt30 mb15">
            <div class="checkbox">
              <input type="checkbox" id="pageId_input_active" v-model="link.pageId_input_active">
              <label for="pageId_input_active">{{ locale.direct_input }}</label>
            </div>
          </div>
          <div v-if="link.pageId_input_active"><input type="text" class="input" v-model="link.pageIdInput"></div>
          <!-- //페이지 리스트를 선택하지 않고 직접 pageid를 입력 -->
          <!-- 페이지 선택 -->
          <p v-else class="currentPage input">
            <a :href="setPageLink(link.pageId)" class="link" target="_blank">{{getPageName(link.pageId)}}</a>
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"><g><g><path d="M412.88,261.464c-11.423,0-20.682,9.259-20.682,20.682v156.879c0,17.43-14.181,31.611-31.612,31.611H72.975c-17.43,0-31.611-14.181-31.611-31.611V151.414c0-17.43,14.181-31.611,31.611-31.611h156.879c11.422,0,20.682-9.26,20.682-20.682c0-11.422-9.26-20.682-20.682-20.682H72.975C32.737,78.439,0,111.176,0,151.414v287.611C0,479.264,32.737,512,72.975,512h287.61c40.239,0,72.976-32.736,72.977-72.975V282.146C433.562,270.723,424.303,261.464,412.88,261.464z"/></g></g><g><g><path d="M491.318,0H334.439c-11.423,0-20.682,9.26-20.682,20.682c0,11.422,9.259,20.682,20.682,20.682h136.197v136.197c0,11.422,9.259,20.682,20.682,20.682c11.423,0,20.682-9.26,20.682-20.682V20.682C512,9.26,502.741,0,491.318,0z"/></g></g><g><g><path d="M505.942,6.058c-8.077-8.076-21.172-8.076-29.249,0L189.082,293.668c-8.077,8.077-8.077,21.172,0,29.249c4.038,4.039,9.332,6.058,14.625,6.058c5.294,0,10.587-2.02,14.625-6.058L505.942,35.307C514.019,27.23,514.019,14.135,505.942,6.058z"/></g></g></svg>
          </p>
          <!-- //페이지 선택 -->
        </div>
        <!-- //페이지 -->
        <!-- 샵 -->
        <div v-else-if="link.type === 'shop'">
          <p class="currentPage input">
            <a :href="setShopLink(link.shopPageId)" class="link" target="_blank">{{getShopPageName}}</a>
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"><g><g><path d="M412.88,261.464c-11.423,0-20.682,9.259-20.682,20.682v156.879c0,17.43-14.181,31.611-31.612,31.611H72.975c-17.43,0-31.611-14.181-31.611-31.611V151.414c0-17.43,14.181-31.611,31.611-31.611h156.879c11.422,0,20.682-9.26,20.682-20.682c0-11.422-9.26-20.682-20.682-20.682H72.975C32.737,78.439,0,111.176,0,151.414v287.611C0,479.264,32.737,512,72.975,512h287.61c40.239,0,72.976-32.736,72.977-72.975V282.146C433.562,270.723,424.303,261.464,412.88,261.464z"/></g></g><g><g><path d="M491.318,0H334.439c-11.423,0-20.682,9.26-20.682,20.682c0,11.422,9.259,20.682,20.682,20.682h136.197v136.197c0,11.422,9.259,20.682,20.682,20.682c11.423,0,20.682-9.26,20.682-20.682V20.682C512,9.26,502.741,0,491.318,0z"/></g></g><g><g><path d="M505.942,6.058c-8.077-8.076-21.172-8.076-29.249,0L189.082,293.668c-8.077,8.077-8.077,21.172,0,29.249c4.038,4.039,9.332,6.058,14.625,6.058c5.294,0,10.587-2.02,14.625-6.058L505.942,35.307C514.019,27.23,514.019,14.135,505.942,6.058z"/></g></g></svg>
          </p>
        </div>
        <!-- //샵 -->
        <!-- 상품 -->
        <div v-else-if="link.type === 'product'">
          <p class="currentPage input">
            <a :href="setProductLink(link.productId)" class="link" target="_blank">{{getProductName(link.productId, link.productCategory)}}</a>
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"><g><g><path d="M412.88,261.464c-11.423,0-20.682,9.259-20.682,20.682v156.879c0,17.43-14.181,31.611-31.612,31.611H72.975c-17.43,0-31.611-14.181-31.611-31.611V151.414c0-17.43,14.181-31.611,31.611-31.611h156.879c11.422,0,20.682-9.26,20.682-20.682c0-11.422-9.26-20.682-20.682-20.682H72.975C32.737,78.439,0,111.176,0,151.414v287.611C0,479.264,32.737,512,72.975,512h287.61c40.239,0,72.976-32.736,72.977-72.975V282.146C433.562,270.723,424.303,261.464,412.88,261.464z"/></g></g><g><g><path d="M491.318,0H334.439c-11.423,0-20.682,9.26-20.682,20.682c0,11.422,9.259,20.682,20.682,20.682h136.197v136.197c0,11.422,9.259,20.682,20.682,20.682c11.423,0,20.682-9.26,20.682-20.682V20.682C512,9.26,502.741,0,491.318,0z"/></g></g><g><g><path d="M505.942,6.058c-8.077-8.076-21.172-8.076-29.249,0L189.082,293.668c-8.077,8.077-8.077,21.172,0,29.249c4.038,4.039,9.332,6.058,14.625,6.058c5.294,0,10.587-2.02,14.625-6.058L505.942,35.307C514.019,27.23,514.019,14.135,505.942,6.058z"/></g></g></svg>
          </p>
        </div>
        <!-- //상품 -->
        <!-- 예약 -->
        <div v-else-if="link.type === 'reservation'">
          <p class="currentPage input">
            <a :href="setReservationLink(link.reservationId)" class="link" target="_blank">{{getReservationName(link.reservationId)}}</a>
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"><g><g><path d="M412.88,261.464c-11.423,0-20.682,9.259-20.682,20.682v156.879c0,17.43-14.181,31.611-31.612,31.611H72.975c-17.43,0-31.611-14.181-31.611-31.611V151.414c0-17.43,14.181-31.611,31.611-31.611h156.879c11.422,0,20.682-9.26,20.682-20.682c0-11.422-9.26-20.682-20.682-20.682H72.975C32.737,78.439,0,111.176,0,151.414v287.611C0,479.264,32.737,512,72.975,512h287.61c40.239,0,72.976-32.736,72.977-72.975V282.146C433.562,270.723,424.303,261.464,412.88,261.464z"/></g></g><g><g><path d="M491.318,0H334.439c-11.423,0-20.682,9.26-20.682,20.682c0,11.422,9.259,20.682,20.682,20.682h136.197v136.197c0,11.422,9.259,20.682,20.682,20.682c11.423,0,20.682-9.26,20.682-20.682V20.682C512,9.26,502.741,0,491.318,0z"/></g></g><g><g><path d="M505.942,6.058c-8.077-8.076-21.172-8.076-29.249,0L189.082,293.668c-8.077,8.077-8.077,21.172,0,29.249c4.038,4.039,9.332,6.058,14.625,6.058c5.294,0,10.587-2.02,14.625-6.058L505.942,35.307C514.019,27.23,514.019,14.135,505.942,6.058z"/></g></g></svg>
          </p>
        </div>
        <!-- //상품 -->
        <!-- 바로가기 -->
        <div v-else-if="link.type === 'shortcut'">
          <p class="currentPage input">
            <a href="#" class="link" @click.prevent>{{getShortcutName(link.shortcutId)}}</a>
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"><g><g><path d="M412.88,261.464c-11.423,0-20.682,9.259-20.682,20.682v156.879c0,17.43-14.181,31.611-31.612,31.611H72.975c-17.43,0-31.611-14.181-31.611-31.611V151.414c0-17.43,14.181-31.611,31.611-31.611h156.879c11.422,0,20.682-9.26,20.682-20.682c0-11.422-9.26-20.682-20.682-20.682H72.975C32.737,78.439,0,111.176,0,151.414v287.611C0,479.264,32.737,512,72.975,512h287.61c40.239,0,72.976-32.736,72.977-72.975V282.146C433.562,270.723,424.303,261.464,412.88,261.464z"/></g></g><g><g><path d="M491.318,0H334.439c-11.423,0-20.682,9.26-20.682,20.682c0,11.422,9.259,20.682,20.682,20.682h136.197v136.197c0,11.422,9.259,20.682,20.682,20.682c11.423,0,20.682-9.26,20.682-20.682V20.682C512,9.26,502.741,0,491.318,0z"/></g></g><g><g><path d="M505.942,6.058c-8.077-8.076-21.172-8.076-29.249,0L189.082,293.668c-8.077,8.077-8.077,21.172,0,29.249c4.038,4.039,9.332,6.058,14.625,6.058c5.294,0,10.587-2.02,14.625-6.058L505.942,35.307C514.019,27.23,514.019,14.135,505.942,6.058z"/></g></g></svg>
          </p>
        </div>
        <!-- //바로가기 -->
        <!-- GV 연동 -->
        <div v-else-if="link.type.includes('interlock')">
          <p class="currentPage input">
            <a href="#" class="link" @click.prevent>{{getInterlockName(link.type, link.interlockId)}}</a>
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"><g><g><path d="M412.88,261.464c-11.423,0-20.682,9.259-20.682,20.682v156.879c0,17.43-14.181,31.611-31.612,31.611H72.975c-17.43,0-31.611-14.181-31.611-31.611V151.414c0-17.43,14.181-31.611,31.611-31.611h156.879c11.422,0,20.682-9.26,20.682-20.682c0-11.422-9.26-20.682-20.682-20.682H72.975C32.737,78.439,0,111.176,0,151.414v287.611C0,479.264,32.737,512,72.975,512h287.61c40.239,0,72.976-32.736,72.977-72.975V282.146C433.562,270.723,424.303,261.464,412.88,261.464z"/></g></g><g><g><path d="M491.318,0H334.439c-11.423,0-20.682,9.26-20.682,20.682c0,11.422,9.259,20.682,20.682,20.682h136.197v136.197c0,11.422,9.259,20.682,20.682,20.682c11.423,0,20.682-9.26,20.682-20.682V20.682C512,9.26,502.741,0,491.318,0z"/></g></g><g><g><path d="M505.942,6.058c-8.077-8.076-21.172-8.076-29.249,0L189.082,293.668c-8.077,8.077-8.077,21.172,0,29.249c4.038,4.039,9.332,6.058,14.625,6.058c5.294,0,10.587-2.02,14.625-6.058L505.942,35.307C514.019,27.23,514.019,14.135,505.942,6.058z"/></g></g></svg>
          </p>
        </div>
        <!-- //GV연동 -->
        <!-- 기능 -->
        <div v-else-if="link.type === 'func'">
          <p class="currentPage input">
            <span class="link">{{getFuncName(link.funcId)}}</span>
          </p>
        </div>
        <!-- //기능 -->
        <!-- sep페이지
        <div v-else-if="link.type === 'sep'">
          <p class="currentPage input">
            <a href="#" class="link" @click.prevent="onOpenSep">{{getSepName(link.sepId)}}</a>
          </p>
        </div>
        //sep페이지 -->
        <!-- 새창 선택 -->
        <span v-if="link.type === 'outlink' || link.type.includes('interlock')" class="mt10 checkbox">
          <input type="checkbox" id="windowTarget" v-model="link.target">
          <label for="windowTarget">{{locale.link_page_target}}</label>
        </span>
        <!-- //새창 선택 -->
        <!-- 페이지만 -->
        <div v-else class="mt10 mb15">
          <div class="checkbox">
            <input type="checkbox" id="link_frame_false" v-model="link.frame_false">
            <label for="link_frame_false">{{ locale.page_pageonly }}</label>
          </div>
        </div>
        <!-- //페이지만 -->
      </div>
      <div class="typeContent">
        <!-- 페이지 연결시 연결할 페이지 리스트 -->
        <div v-if="link.type === 'page' && !link.pageId_input_active">
          <!-- <button type="button" class="btn btnFull" @click="onSelectPage">{{locale.link_set_page}}</button> -->
          <!-- page list -->
          <div class="pageList mt15">
            <div class="pageSearch mb10">
              <!-- <button type="button" :class="{btnSearchType: true, active: search === 'category'}" title="category" @click="onOpenCateogry"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m152.1875 213.066406h207.621094c12.480468 0 22.632812-10.152344 22.632812-22.632812v-146.300782c0-10.761718-8.753906-19.515624-19.511718-19.515624h-113.246094c-1.71875 0-3.265625-.957032-4.035156-2.496094l-7.421876-14.847656c-2.246093-4.488282-6.753906-7.273438-11.769531-7.273438h-83.742187c-7.253906 0-13.15625 5.902344-13.15625 13.15625v177.277344c0 12.480468 10.152344 22.632812 22.628906 22.632812zm73.128906-198.066406 6.914063 13.828125c3.328125 6.65625 10.011719 10.789063 17.453125 10.789063h113.246094c2.488281 0 4.511718 2.023437 4.511718 4.515624v12.277344h-151.773437c-4.144531 0-7.5 3.359375-7.5 7.5 0 4.144532 3.355469 7.5 7.5 7.5h151.773437v114.582032c0 6.65625-5.414062 12.074218-12.066406 12.074218h-198.75c-6.652344 0-12.066406-5.417968-12.066406-12.074218v-114.582032h37.773437c4.144531 0 7.5-3.355468 7.5-7.5 0-4.140625-3.355469-7.5-7.5-7.5h-37.773437v-41.410156zm0 0"/><path d="m314.121094 381.402344h-60.953125l-3.765625-7.535156c-1.804688-3.605469-5.429688-5.84375-9.460938-5.84375h-45.515625c-5.832031 0-10.574219 4.742187-10.574219 10.574218v93.941406c0 10 8.136719 18.136719 18.136719 18.136719h108.023438c10 0 18.136719-8.136719 18.136719-18.136719v-77.105468c0-7.738282-6.292969-14.03125-14.027344-14.03125zm-.972656 91.136718c0 1.730469-1.40625 3.140626-3.136719 3.140626h-108.023438c-1.730469 0-3.136719-1.410157-3.136719-3.140626v-89.515624h38.355469l2.8125 5.625c2.390625 4.78125 7.199219 7.753906 12.546875 7.753906h60.582032zm0 0"/><path d="m130.269531 381.402344h-60.953125l-3.765625-7.535156c-1.804687-3.605469-5.429687-5.84375-9.460937-5.84375h-45.515625c-5.832031 0-10.574219 4.742187-10.574219 10.574218v93.941406c0 10 8.136719 18.140626 18.136719 18.140626h108.023437c10 0 18.136719-8.140626 18.136719-18.140626v-29.449218c0-4.144532-3.359375-7.5-7.5-7.5s-7.5 3.355468-7.5 7.5v29.449218c0 1.730469-1.40625 3.140626-3.136719 3.140626h-108.023437c-1.730469 0-3.136719-1.410157-3.136719-3.140626v-89.515624h38.355469l2.8125 5.625c2.390625 4.78125 7.199219 7.753906 12.546875 7.753906h60.582031v15.9375c0 4.140625 3.355469 7.5 7.5 7.5 4.140625 0 7.5-3.359375 7.5-7.5v-16.90625c0-7.738282-6.292969-14.03125-14.027344-14.03125zm0 0"/><path d="m497.972656 381.402344h-60.953125l-3.765625-7.535156c-1.804687-3.605469-5.429687-5.84375-9.457031-5.84375h-45.519531c-5.832032 0-10.574219 4.742187-10.574219 10.574218v93.941406c0 10 8.136719 18.136719 18.136719 18.136719h17.828125c4.140625 0 7.5-3.355469 7.5-7.5 0-4.140625-3.359375-7.5-7.5-7.5h-17.828125c-1.730469 0-3.136719-1.40625-3.136719-3.136719v-89.519531h38.355469l2.8125 5.628907c2.390625 4.78125 7.199218 7.753906 12.546875 7.753906h60.582031v76.136718c0 1.730469-1.40625 3.140626-3.136719 3.140626h-58.527343c-4.144532 0-7.5 3.355468-7.5 7.5 0 4.140624 3.355468 7.5 7.5 7.5h58.527343c10 0 18.136719-8.140626 18.136719-18.140626v-77.105468c0-7.738282-6.292969-14.03125-14.027344-14.03125zm0 0"/><path d="m72.148438 359.527344c4.140624 0 7.5-3.355469 7.5-7.5v-36.3125c0-5.878906 4.78125-10.664063 10.660156-10.664063h158.191406v46.976563c0 4.144531 3.359375 7.5 7.5 7.5s7.5-3.355469 7.5-7.5v-46.976563h158.191406c5.878906 0 10.660156 4.785157 10.660156 10.664063v36.3125c0 4.144531 3.359376 7.5 7.5 7.5 4.140626 0 7.5-3.355469 7.5-7.5v-36.3125c0-14.152344-11.511718-25.664063-25.660156-25.664063h-158.191406v-52.023437c0-4.144532-3.359375-7.5-7.5-7.5s-7.5 3.355468-7.5 7.5v52.023437h-158.191406c-14.148438 0-25.660156 11.511719-25.660156 25.664063v36.3125c0 4.144531 3.359374 7.5 7.5 7.5zm0 0"/></svg></button> -->
              <button type="button" :class="{btnSearchType: true, active: search === 'all'}" title="all pages" @click="onAllPages"><img src="~@/assets/img/ico_search.svg" alt=""></button>
              <input type="text" class="input" v-model="searchWord" @keyup="searchPage">
              <!-- category layer -->
              <div v-show="categoryOpen" class="categoryLayer">
                <button type="button" class="btnCloseCategory" @click="onCloseCategory"><img src="~@/assets/img/ico_close_black.svg" alt="" /></button>
                <CategoryList
                  :mode="'compact'"
                  :option="categoryOption"
                  :setCheck="checkedCategory"
                  :state="categoryState"
                  @selected="selectCategory" />
              </div>
              <!-- //category layer -->
            </div>
            <div class="searchResult">
              <ul v-if="pageList.length > 0" class="list">
                <li class="mt5">
                  <span class="checkbox radio">
                    <input type="radio" :name="`${id}_pagelist_main`" :id="`${id}_page_main`" value="main" v-model="link.pageId">
                    <label :for="`${id}_page_main`"><span class="name">{{locale.main_page}}</span></label>
                  </span>
                </li>
                <li v-for="page in pageList" :key="page.pageData.id" class="mt5">
                  <span class="checkbox radio">
                    <input type="radio" :name="`${id}_pagelist`" :id="`${id}_page_${page.pageData.id}`" :value="page.pageData.id" v-model="link.pageId">
                    <label :for="`${id}_page_${page.pageData.id}`"><span class="name">{{page.pageData.title}}</span></label>
                  </span>
                </li>
              </ul>
              <div v-else class="message">{{message}}</div>
            </div>
          </div>
          <!-- //page list -->
        </div>
        <!-- //페이지 연결시 연결할 페이지 리스트 -->
        <!-- 샵 페이지 연결 -->
        <div v-if="link.type === 'shop'">
          <!-- 샵을 스토어로 -->
          <div class="mb15">
            <div class="checkbox">
              <input type="checkbox" id="link_shop_to_store" v-model="link.shopToStore">
              <label for="link_shop_to_store">STORE로 연결</label>
            </div>
          </div>
          <!-- //페이지만 -->
          <!-- shop list -->
          <div class="mt15">
            <div class="searchResult">
              <ul v-if="shopList.length > 0" class="list">
                <li v-for="shop in shopList" :key="shop.pageId" class="mt5">
                  <span class="checkbox radio">
                    <input type="radio" :name="`${id}_shoplist`" :id="`${id}_shop_${shop.pageId}`" :value="shop.pageId" v-model="link.shopPageId" @change="shopCategoryInit">
                    <label :for="`${id}_shop_${shop.pageId}`"><span class="name">{{shop.pageName}}</span></label>
                  </span>
                  <!-- shop category -->
                  <div v-if="link.shopPageId === shop.pageId && shopCategory.length" class="mb10 ml15">
                    <ul>
                      <li class="mt5">
                        <div class="checkbox radio">
                          <input type="radio" :name="`${id}_shopCategory`" :id="`${id}_${shop.pageId}_none`" value="" v-model="link.shopCategoryId">
                          <label :for="`${id}_${shop.pageId}_none`">지정안함</label>
                        </div>
                      </li>
                      <li v-for="cate in shopCategory" :key="cate.id" class="mt5">
                        <div class="checkbox radio">
                          <input type="radio" :name="`${id}_shopCategory`" :id="`${id}_${shop.pageId}_${cate.categoryId}`" :value="cate.categoryId" v-model="link.shopCategoryId">
                          <label :for="`${id}_${shop.pageId}_${cate.categoryId}`">{{cate.label[lang.default]}}</label>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <!-- //shop category -->
                </li>
              </ul>
              <div v-else class="message">{{message}}</div>
            </div>
          </div>
          <!-- //shop list -->
        </div>
        <!-- //샵 페이지 연결 -->
        <!-- 상품리스트 연결 -->
        <div v-if="link.type === 'product'">
          <!-- product list -->
          <div class="mt15">
            <div class="mb10">
              <input type="text" class="input" :placeholder="locale.search_product_list" v-model="searchWordProduct" @keyup="searchProduct">
            </div>
            <div class="searchResult">
              <ul v-if="productList.length > 0" class="list">
                <li v-for="product in productList" :key="product.id" class="mt5">
                  <span class="checkbox radio">
                    <input type="radio" :name="`${id}_productlist`" :id="`${id}_product_${product.id}`" :value="product.id" v-model="link.productId" @change="productCategoryInit">
                    <label :for="`${id}_product_${product.id}`"><span class="name">{{product.title}}</span></label>
                  </span>
                  <!-- product category -->
                  <div v-if="link.productId === product.id && productCategory.length" class="mb10 ml15">
                    <ul>
                      <li v-for="cate in productCategory" :key="cate.id" class="mt5">
                        <div class="checkbox radio">
                          <input type="radio" :name="`${id}_productCategory`" :id="`${id}_${product.id}_${cate.id}`" :value="cate.id" v-model="link.productCategory">
                          <label :for="`${id}_${product.id}_${cate.id}`">{{cate.label[lang.default]}}</label>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <!-- //product category -->
                </li>
              </ul>
              <div v-else class="message">{{message}}</div>
            </div>
          </div>
          <!-- //page list -->
        </div>
        <!-- //상품리스트 연결 -->
        <!-- 예약 연결 -->
        <div v-if="link.type === 'reservation'">
          <!-- reservation list -->
          <div class="mt15">
            <div class="mb10">
              <input type="text" class="input" :placeholder="locale.search_reservation_list" v-model="searchWordReservation" @keyup="searchReservation">
            </div>
            <div class="searchResult">
              <ul v-if="reservationList.length > 0" class="list">
                <li v-for="reservation in reservationList" :key="reservation.id" class="mt5">
                  <span
                    class="checkbox radio"
                    :class="{disabled: isDisabled('reservation', reservation.id)}">
                    <input
                      type="radio"
                      :name="`${id}_reservationList`"
                      :id="`${id}_reservation_${reservation.id}`"
                      :value="reservation.id"
                      :disabled="isDisabled('reservation', reservation.id)"
                      v-model="link.reservationId">
                    <label :for="`${id}_reservation_${reservation.id}`"><span class="name">{{reservation.title}}</span></label>
                  </span>
                </li>
              </ul>
              <div v-else class="message">{{message}}</div>
            </div>
          </div>
          <!-- //reservation list -->
        </div>
        <!-- //예약 연결 -->
        <!-- 바로가기 연결 -->
        <div v-else-if="link.type === 'shortcut'">
          <!-- <button type="button" class="btn btnFull" @click="onSelectShortcut">{{locale.link_set_shortcut}}</button> -->
          <div class="searchResult mt15">
            <ul class="list">
              <li v-for="shortcut in shortcutList" :key="shortcut.id" class="mt5">
                <span class="checkbox radio">
                  <input type="radio" :name="`${id}_shortcutlist`" :id="`${id}_shortcut_${shortcut.id}`" :value="shortcut.id" v-model="link.shortcutId">
                  <label :for="`${id}_shortcut_${shortcut.id}`"><span class="name">{{shortcut.label}}</span></label>
                </span>
                <!-- 바로가기:: 지역정보 -->
                <div v-if="shortcut.id === 'localinfo' && link.shortcutId === 'localinfo'" class="localinfoSelect">
                  <div v-if="localinfotype.length">
                    <select name="" id="" class="input" v-model="setLocalInfoType">
                      <option value="selection">{{locale.localinfo_selection}}</option>
                      <option v-for="localinfo in localinfotype" :key="localinfo" :value="localinfo">{{getLocalInfoTypeName(localinfo)}}</option>
                    </select>
                  </div>
                  <div v-else class="noData colorGrey">{{locale.link_localinfo_nodata}}</div>
                </div>
                <!-- 바로가기:: 지역정보 -->
              </li>
            </ul>
          </div>
        </div>
        <!-- //바로가기 연결 -->
        <!-- 기능 -->
        <div v-else-if="link.type === 'func'">
          <div class="searchResult mt15">
            <ul class="list">
              <li v-for="func in funcList" :key="func.id" class="mt5">
                <span class="checkbox radio">
                  <input type="radio" :name="`${id}_func`" :id="`${id}_func_${func.id}`" :value="func.id" v-model="link.funcId">
                  <label :for="`${id}_func_${func.id}`">
                    <span class="name">{{func.label}}</span>
                    <button v-if="func.id === 'ticket' && ticketFunc" type="button" class="btn btnWhite sizeXs ml15" @click="copyTicketUUID">{{ locale.copy_ticketid }}</button>
                  </label>
                </span>
                <div v-if="func.id === 'eventTrigger'" class="mt5 ml15">
                  <input type="text" class="input" v-model="link.eventTriggerFunc" :disabled="link.funcId !== 'eventTrigger'" />
                </div>
                <!-- <div v-if="func.id === 'ticket'" class="mt5 ml15">
                  <input type="text" class="input" v-model="ticketFunc" disabled />
                </div> -->
              </li>
            </ul>
          </div>
        </div>
        <!-- //기능 -->
        <!-- GV연동 설정 -->
        <div v-else-if="link.type.includes('interlock')">
          <!-- <button type="button" class="btn btnFull" @click="onSelectInterlock('gv')">{{locale.link_set_interlock}}</button> -->
          <div class="searchResult mt15">
            <ul class="list">
              <li v-for="gv in interlockList.gv" :key="gv.id" class="mt5">
                <span class="checkbox radio">
                  <input type="radio" :name="`${id}_interlock`" :id="`${id}_interlock_${gv.id}`" :value="gv.id" v-model="link.interlockId">
                  <label :for="`${id}_interlock_${gv.id}`"><span class="name">{{gv.label}}</span></label>
                </span>
              </li>
            </ul>
          </div>
        </div>
        <!-- //GV연동 설정 -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SetLanguageValue from '@/components/Util/SetLanguageValue'
import CategoryList from '@/components/Category/List'
import regExp from '@/common/regExp'
import UNIQUE from '@/common/unique'
// import Sep from '@/views/Sep'

export default {
  name: 'SetLink',
  props: [
    'link',
    'fix',
    'pageIdInput', // 서로 다른 사이트의 페이지id를 입력할 수 있는지?
    'checkedInfo' // 이미 다른 곳에서 선택한 값은 다시 선택할 수 없도록
  ],
  components: {
    SetLanguageValue,
    CategoryList,
    // Sep
  },
  computed: {
    ...mapGetters({
      getPageList: 'page/list',
      getProductList: 'product/list',
      getReservationList: 'reservation/list',
      getShopPageList: 'shop/getShopPageList',
      checkedCategory: 'category/getChecked',
      localinfotype: 'localinfo/getType',
      sepList: 'sep/sepList'
    }),
    directInfo () {
      return {
        siteid: this.$store.state.authentication.userInfo.siteid,
        lang: this.$store.state.setting.lang.default
      }
    },
    locale () {
      return this.$store.state.service.locale.data
    },
    pages () {
      const sort = 'updateat'
      const pages = this._.cloneDeep(this.getPageList)
      const list = Sort(pages)
      function Sort (arr) {
        return arr.sort(function (a, b) {
          a[sort] = a[sort] ? a[sort] : a.createat
          b[sort] = b[sort] ? b[sort] : b.createat
          return a[sort] > b[sort] ? -1 : a[sort] < b[sort] ? 1 : 0
        })
      }
      return list
    },
    shops () {
      const sort = 'updateat'
      const shops = this._.cloneDeep(this.getShopPageList)
      const list = Sort(shops)
      function Sort (arr) {
        return arr.sort(function (a, b) {
          a[sort] = a[sort] ? a[sort] : a.createat
          b[sort] = b[sort] ? b[sort] : b.createat
          return a[sort] > b[sort] ? -1 : a[sort] < b[sort] ? 1 : 0
        })
      }
      return list
    },
    products () {
      const sort = 'updateat'
      const products = this._.cloneDeep(this.getProductList)
      const list = Sort(products)
      function Sort (arr) {
        return arr.sort(function (a, b) {
          a[sort] = a[sort] ? a[sort] : a.createat
          b[sort] = b[sort] ? b[sort] : b.createat
          return a[sort] > b[sort] ? -1 : a[sort] < b[sort] ? 1 : 0
        })
      }
      return list
    },
    reservations () {
      const sort = 'updateat'
      const reservations = this._.cloneDeep(this.getReservationList)
      const list = Sort(reservations)
      function Sort (arr) {
        return arr.sort(function (a, b) {
          a[sort] = a[sort] ? a[sort] : a.createat
          b[sort] = b[sort] ? b[sort] : b.createat
          return a[sort] > b[sort] ? -1 : a[sort] < b[sort] ? 1 : 0
        })
      }
      return list
    },
    message () {
      let message = ''
      if (this.link.type === 'page') {
        if (this._.isEmpty(this.selectedCategory)) {
          message = this.locale.link_page_select_category
        } else if (this.pageList.length === 0) {
          message = this.locale.link_page_nodata
        }
      } else if (this.link.type === 'product') {
        if (this.productList.length === 0) {
          message = this.locale.product_nodata
        }
      }
      return message
    },
    partner () {
      return this.$store.state.service.partner
    },
    shortcutList () {
      const commonShortcut = [
        { id: 'coupon', label: this.locale.coupon },
        { id: 'amenity', label: this.locale.amenity },
        { id: 'control', label: this.locale.roomcontrol },
        { id: 'tv', label: this.locale.tv_channel_guide },
        { id: 'mypage', label: this.locale.mypage },
        { id: 'cart', label: this.locale.cart },
        { id: 'myOrder', label: this.locale.orderhistory },
        { id: 'morningcall', label: this.locale.morningcall },
        { id: 'parking', label: this.locale.parking_information },
        { id: 'mobility', label: this.locale.mobility },
        { id: 'talk', label: this.locale.staytalk },
        { id: 'mobilekey', label: this.locale.mobilekey },
        { id: 'waitingcall/nationality', label: `${this.locale.waitingcall}-국적선택` },
        { id: 'waitingcall/domestic', label: `${this.locale.waitingcall}-내국인` },
        { id: 'waitingcall/foreign', label: `${this.locale.waitingcall}-외국인` }
      ]
      const nsjShortcut = [
        { id: 'localinfo', label: this.locale.localinfo }
      ]
      return this.partner === 'NSJ' ? commonShortcut.concat(nsjShortcut) : commonShortcut
    },
    interlockList () {
      return {
        gv: [
          // { id: 'home', label: 'Home' },
          { id: 'controls', label: 'Controls' },
          { id: 'amenity', label: this.locale.amenity },
          { id: 'tv', label: this.locale.tvcontrol }
        ]
      }
    },
    funcList () {
      return [
        { id: 'roomkey', label: this.locale.link_func_roomkey },
        { id: 'eventTrigger', label: '이벤트 트리거' },
        { id: 'ticket', label: '티켓' }
      ]
    },
    setLocalInfoType: {
      get () {
        const isLocalinfo = this.link.type === 'shortcut' && this.link.shortcutId === 'localinfo'
        return isLocalinfo && typeof (this.link.localinfotype) === 'undefined' ? 'selection' : this.link.localinfotype
      },
      set (type) {
        this.link.localinfotype = type
      }
    },
    fixList () {
      const fix = typeof (this.fix) === 'string' ? [this.fix] : this.fix
      return this.fix ? fix : null
    },
    getShopPageName () {
      const shopPageId = this.link.shopPageId
      const shopCategoryId = this.link.shopCategoryId
      const name = !shopPageId
        ? 'placeholder'
        : this.shops.find(x => x.pageId === shopPageId)
          ? this.shops.find(x => x.pageId === shopPageId).pageName
          : '존재하지 않는 샵페이지입니다.'
      const cateName = shopCategoryId
        ? this.shopCategory.find(x => x.categoryId === shopCategoryId)
          ? ` - ${this.shopCategory.find(x => x.categoryId === shopCategoryId).label[this.lang.default]}`
          : ''
        : ''
      return `${name}${cateName}`
    }
  },
  watch: {
    pages (list) {
      this.pageList = list
    },
    shops (list) {
      this.shopList = list
    },
    products (list) {
      this.productList = list
    },
    reservations (list) {
      this.reservationList = list
    },
    link: {
      deep: true,
      handler (link) {
        if (link.type === 'product' && link.productId) {
          const productId = link.productId
          this.$store.dispatch('product/getProductItem', productId).then((res) => {
            this.productCategory = res.category.map(x => {
              return {
                id: x.data.id,
                label: x.data.label
              }
            }).filter(x => x.id !== '')
          })
        } else if (link.type === 'shop' && link.shopPageId) {
          const shopPageId = link.shopPageId
          this.$store.dispatch('shop/getShopCategory', shopPageId).then((res) => {
            if (res && res.message && res.message.categories) {
              this.shopCategory = res.message.categories.map(x => {
                return {
                  categoryId: x.categoryId,
                  label: x.categoryLabel
                }
              })
            } else {
              this.shopCategory = []
            }
          })
        }
      }
    }
  },
  created () {
    this.$store.dispatch('page/setPageListData')
    this.$store.dispatch('product/setProductListData')
    this.$store.dispatch('reservation/setReservationListData')
    this.$store.dispatch('shop/getShopPageList')
    this.id = UNIQUE.fileid()
    // this.$store.dispatch('sep/getSepList')
    // this.$store.dispatch('localinfo/getLocalList').then(() => {
    //   this.$store.dispatch('localinfo/getLocalInfoType')
    // })
    this.originInfo = this._.cloneDeep(this.link)
    if (this.link.ticketFunc) {
      this.ticketFunc = this.link.ticketFunc || ''
    }
  },
  beforeDestroy () {
    // destroy 전 링크전부를 부모컴포넌트로 보냄
    const data = {
      ...this.link,
      title: this.getTitle()
    }
    this.$emit('sendInfo', data)
  },
  data () {
    return {
      id: '',
      selectPage: false,
      selectShortcut: false,
      selectInterlock: false,
      lang: this.$store.state.setting.lang,
      layer: false,
      defaultValue: ' ',
      search: 'all', // all, category
      selectedCategory: '',
      categoryOpen: false,
      categoryOption: {
        selected: true,
        editItem: false
      },
      categoryState: {
        checked: true
      },
      pageList: [],
      shopList: [],
      productList: [],
      reservationList: [],
      filteredList: [],
      searchWord: '',
      searchWordProduct: '',
      searchWordReservation: '',
      sepOpen: false,
      shopCategory: [],
      productCategory: [],
      originInfo: null,
      ticketFunc: ''
    }
  },
  methods: {
    isDisabled (type, id) {
      /**
       * 이미 체크가 되어 있는 다른 값이 있다면 선택하지 못함
       * 우선 예약에만 적용
       * -> uuid에 따라 특정 데이터 조회가 필요하기 때문에(패키지 게스트 예약제한)
       */
      const checkedInfo = this.checkedInfo && this.checkedInfo[type]
      const originInfo = this.originInfo
      const originType = originInfo && originInfo.type && `${originInfo.type}Id`
      const originId = originInfo && originInfo[originType]
      return originId !== id && checkedInfo && checkedInfo.includes(id)
    },
    selectCategory (item) {
      this.selectedCategory = item.id
      const filtered =
        this.selectedCategory === 'uncategorized'
          ? this.pages.filter(x => x.pageData.category === null)
          : this.pages.filter(x => x.pageData.category !== null && x.pageData.category.indexOf(item.id) !== -1)
      this.filteredList = filtered
      this.pageList = filtered
    },
    onLayerOpen (item) {
      this.layer = true
    },
    onLayerClose () {
      this.layer = false
    },
    setDefaultVal (url) {
      const defaultLang = this.lang.default
      Object.keys(url).forEach(function (x) {
        if (regExp.replaceAllEmpty(url[x]) === '') {
          url[x] = url[defaultLang]
        }
      })
    },
    setPageLink (pageId) {
      const info = this.directInfo
      const pageUrl = `/viewer/index.html?site=${info.siteid}#/${info.lang}/page/${pageId}`
      return pageUrl
    },
    setShopLink (shopPageId) {
      const info = this.directInfo
      const productUrl = `/viewer/index.html?site=${info.siteid}#/${info.lang}/shop/${shopPageId}`
      return productUrl
    },
    setProductLink (productId) {
      const info = this.directInfo
      const productUrl = `/viewer/index.html?site=${info.siteid}#/${info.lang}/product/${productId}`
      return productUrl
    },
    setReservationLink (reservationId) {
      const info = this.directInfo
      const reservationUrl = `/viewer/index.html?site=${info.siteid}#/${info.lang}/reservation/${reservationId}`
      return reservationUrl
    },
    onSelectPage () {
      this.selectPage = !this.selectPage
    },
    onOpenCateogry () {
      this.categoryOpen = true
      this.search = 'category'
      this.pageList = this.filteredList
    },
    onCloseCategory () {
      this.categoryOpen = false
    },
    onAllPages () {
      this.categoryOpen = false
      this.search = 'all'
      this.pageList = this.pages
    },
    getFuncName (id) {
      const locale = id || 'placeholder'
      const funcName = `link_func_${locale}`
      const evtTriggerMessage = this.link.eventTriggerFunc || '-'
      return id === 'eventTrigger'
        ? `event trigger (${evtTriggerMessage})`
        : id === 'ticket'
          ? 'ticket'
          : `${this.locale[funcName]}`
    },
    getPageName (id) {
      const name = !id || id === ''
        ? this.locale.link_page_placeholder
        : id === 'main'
          ? this.locale.main_page
          : this.pages.find(x => x.pageData.id === id)
            ? this.pages.find(x => x.pageData.id === id).pageData.title
            : this.locale.link_page_notexist
      return name
    },
    getProductName (id, category) {
      const name = !id
        ? this.locale.link_product_placeholder
        : this.products.find(x => x.id === id)
          ? this.products.find(x => x.id === id).title
          : this.locale.link_product_notexist
      const cateName = category
        ? this.productCategory.find(x => x.id === category)
          ? ` - ${this.productCategory.find(x => x.id === category).label[this.lang.default]}`
          : ''
        : ''
      return `${name}${cateName}`
    },
    getReservationName (id) {
      const name = !id
        ? this.locale.link_reservation_placeholder
        : this.reservations.find(x => x.id === id)
          ? this.reservations.find(x => x.id === id).title
          : this.locale.link_reservation_notexist
      return name
    },
    getSepName (id) {
      const name = typeof (id) === 'undefined' || id === ''
        ? 'SEP 페이지를 선택하세요'
        : typeof (this.sepList.find(x => x.id === id)) === 'undefined'
          ? '존재하지 않는 페이지입니다'
          : this.sepList.find(x => x.id === id).title
      return name
    },
    onSelectShortcut () {
      this.selectShortcut = !this.selectShortcut
    },
    getShortcutName (id) {
      let name = this.locale.link_shortcut_placeholder
      if (!!id && id.length) {
        name = this.shortcutList.find(x => x.id === id) ? this.shortcutList.find(x => x.id === id).label : ''
      }
      return name
    },
    getLocalInfoTypeName (type) {
      const localinfotype = `localinfo_${type}`
      return this.locale[localinfotype]
    },
    onSelectInterlock () {
      this.selectInterlock = !this.selectInterlock
    },
    getInterlockName (channel, id) {
      const channels = channel.split('_')
      const ch = channels[channels.length - 1]
      const name = typeof (id) === 'undefined' || id === ''
        ? this.locale.link_interlock_placeholder
        : this.interlockList[ch].find(x => x.id === id).label
      return name
    },
    searchPage () {
      const word = this.searchWord.toLowerCase().trim()
      function findWord (arr, word) {
        return arr.filter(x => x.pageData.title.toLowerCase().trim().includes(word))
      }
      if (word.length > 0) {
        this.pageList = this.search === 'all' ? findWord(this.pages, word) : findWord(this.pageList, word)
      }
    },
    searchProduct () {
      const word = regExp.replaceAllEmpty(this.searchWordProduct.toLowerCase())
      if (word.length > 0) {
        this.productList = this.products.filter(x => regExp.replaceAllEmpty(x.title).includes(word))
      } else {
        this.productList = this.products
      }
    },
    searchReservation () {
      const word = regExp.replaceAllEmpty(this.searchWordReservation.toLowerCase())
      if (word.length > 0) {
        this.reservationList = this.reservations.filter(x => regExp.replaceAllEmpty(x.title).includes(word))
      } else {
        this.reservationList = this.reservations
      }
    },
    shopCategoryInit () {
      delete this.link.shopCategory
    },
    productCategoryInit () {
      delete this.link.productCategory
    },
    applySep (sepId) {
      this.link.sepId = sepId
      this.sepOpen = false
    },
    onOpenSep () {
      const sepId = this.link.sepId
      this.$store.commit('sep/setSepPage', sepId)
      this.sepOpen = true
    },
    onCloseSep () {
      this.sepOpen = false
    },
    copyTicketUUID () {
      navigator.clipboard.writeText(this.ticketFunc)
      .then(() => {
        alert(this.locale.complete_copy)
      })
      .catch(err => {
        console.error('복사 실패:', err)
      })
    },
    getTitle () {
      let result = ''
      if (this.link.type === 'page') {
        result = this.getPageName(this.link.pageId)
      } else if (this.link.type === 'product') {
        result = this.getProductName(this.link.productId)
      } else if (this.link.type === 'shortcut') {
        result = this.getShortcutName(this.link.shortcutId)
      } else if (this.link.type === 'outlink') {
        result = this.link.url[this.lang.default]
      }
      return result
    },
  }
}
</script>

<style lang="scss" scoped>
.linkType {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2px;
  .checkbox {
    margin-right: 0;
  }
}
.currentPage {
  position: relative;
  a {
    display: block;
    min-height: 1.5em;
    padding-right: 1.2em;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  svg {
    position: absolute;
    top: 50%;
    right: 0.8em;
    margin-top: -6px;
    fill: $color-blue;
    width: 12px;
  }
}
.pageSearch {
  position: relative;
  .input {
    padding-left: calc(40px + 0.5em) !important;
  }
  .btnSearchType {
    position: absolute;
    top: 1px;
    left: 1px;
    bottom: 1px;
    width: 40px;
    padding-top: 4px;
    border-right: 1px solid $color-lgrey2;
    opacity: 0.5;
    img {
      width: 22px;
      opacity: 0.4;
    }
  }
}
.searchResult {
  min-height: 3.5em;
  max-height: 20.2em;
  padding-bottom: 0.5em;
  overflow: auto;
  .message {
    padding-top: 0.75em;
    text-align: center;
  }
}
.localinfoSelect {
  margin-top: 10px;
  margin-left: 2em;
}
</style>
